// web/src/shell/Breadcrumbs.tsx — location-aware breadcrumb trail (M0.4),
// resolved from the IA in nav.ts. The trailing crumb is the current page (no
// link). Token-only styling in shell.css.
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Icon } from '../components/ui/Icon';
import { crumbsFor } from './nav';

export function Breadcrumbs(): React.JSX.Element {
  const { pathname } = useLocation();
  const crumbs = crumbsFor(pathname);
  return (
    <nav className="bgCrumbs" aria-label="Breadcrumb">
      <ol>
        {crumbs.map((c, i) => {
          const last = i === crumbs.length - 1;
          return (
            <li key={`${c.label}-${i}`} className="bgCrumb">
              {c.path && !last ? (
                <Link to={c.path} className="bgCrumbLink">
                  {c.label}
                </Link>
              ) : (
                <span aria-current={last ? 'page' : undefined} className="bgCrumbCurrent">
                  {c.label}
                </span>
              )}
              {!last && (
                <Icon icon={ChevronRight} size="xs" tone="subtle" className="bgCrumbSep" />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
